import { Tooltip } from '@mui/material';
import { FilterAlt } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';
import StyledButton from 'components/StyledButton';


/* ---------- Helpers ---------- */
const normalizeValue = (v) => {
    if (v === null || v === undefined || v === '') return null;
    if (Array.isArray(v) && v.length === 0) return null;
    return v;
};

const isEqual = (a, b) => {
    if (Array.isArray(a) && Array.isArray(b)) {
        if (a.length !== b.length) return false;
        return a.every((v, i) => v === b[i]);
    }
    return a === b;
};

const getChangedEntries = (filters = {}, defaultFilters = {}) =>
    Object.entries(filters).filter(([key, value]) => {
        const current = normalizeValue(value);
        const def = normalizeValue(defaultFilters[key]);

        // cả hai đều mặc định
        if (current === null && def === null) return false;

        return !isEqual(current, def);
    });



const FilterButton = ({ filters, defaultFilters, onClick }) => {
    const theme = useTheme();
    const safeFilters = filters ?? {};
    const changedEntries = getChangedEntries(safeFilters, defaultFilters);
    const isFilterChanged = changedEntries.length > 0;

    const tooltipTitle = changedEntries
        .map(([k, v]) => `${k}: ${Array.isArray(v) ? v.join(', ') : v}`)
        .join('\n');

    const button = (
        <StyledButton
            onClick={onClick}
            sx={{
                boxShadow: isFilterChanged
                    ? `inset 0 0 0 1px ${theme.palette.primary.main}`
                    : 'none',
            }}
        >
            <FilterAlt />
        </StyledButton>
    );

    if (!isFilterChanged) return button;

    return (
        <Tooltip
            title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipTitle}</span>}
            arrow
        >
            <span>
                {button}
            </span>
        </Tooltip>
    );
};

export default FilterButton;
